import { GameConfig, type Obstacle, type Player } from './game-types';

interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export const rectsOverlap = (a: Rect, b: Rect): boolean =>
  a.x < b.x + b.width &&
  a.x + a.width > b.x &&
  a.y < b.y + b.height &&
  a.y + a.height > b.y;

// COLLISION_INSET shrinks the hitbox on all sides so sprite edges don't
// register unfair hits.
export const playerHitsObstacle = (
  player: Player,
  obstacle: Obstacle,
): boolean => {
  const inset = GameConfig.COLLISION_INSET;
  return (
    player.x + inset < obstacle.x + obstacle.width - inset &&
    player.x + player.width - inset > obstacle.x + inset &&
    player.y + inset < obstacle.y + obstacle.height - inset &&
    player.y + player.height - inset > obstacle.y + inset
  );
};

// Carts physically clear any cone whose hitbox they overlap, keeping the
// cart's lane free. Without this, a cart+cone jam near the player becomes
// unwinnable.
export const removeConesToppledByCarts = (
  obstacles: Obstacle[],
): Obstacle[] => {
  const carts = obstacles.filter((o) => o.type === 'cart');
  if (carts.length === 0) return obstacles;
  return obstacles.filter((o) => {
    if (o.type !== 'floor') return true;
    return !carts.some((c) => rectsOverlap(c, o));
  });
};
